import React, { useEffect } from 'react';
import WalletDashboardCard from '../../components/WalletDashboardCard';
import { useTour } from '../../hooks/useTour';


const OffRamp = () => {
  const { startTour } = useTour();

  useEffect(() => {
    document.title = "Sell - KAXAA Wallet";
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      startTour(false);
    }, 1500);
    return () => clearTimeout(timer);
  }, [startTour]);


  return (
    <>
      <div className="">
        <main className="">
          <div className="wallet-dashboard">
            <div className="grid grid-cols-[600px_1fr] gap-[30px] items-start">
              <div className="sticky top-10">
                <WalletDashboardCard />
                <div className='card account-card'>
                  <div className='flex gap-2'>
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" style={{ minWidth: '18px' }} viewBox="0 0 24 24"><g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"><circle cx="12" cy="12" r="10" /><path d="M12 16v-4m0-4h.01" /></g></svg>
                    Please exchange Kaxaa for USDC and Sell the funds to your bank account.
                  </div>
                </div>
              </div>
              <div id="tour-sell-container" style={{ maxWidth: '650px' }}>
                <h1 className="text-2xl font-semibold mb-4">Sell</h1>
                
                <div className="card account-card border-0 shadow-sm p-5 text-center my-4" style={{ borderRadius: '16px' }}>
                  <div className="d-flex justify-content-center mb-3">
                    <div className="p-3 rounded-circle" style={{ backgroundColor: 'rgba(161, 204, 60, 0.15)', color: 'var(--accent-color)' }}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.5">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z" />
                      </svg>
                    </div>
                  </div>
                  <h3 className="font-semibold text-xl mb-2">Stripe Payout Coming Soon</h3>
                  <p className="text-muted text-sm max-w-md mx-auto mb-0">
                    We are integrating Stripe payout for fast and direct fiat off-ramping to your bank account.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </>
  );
};

export default OffRamp;
